import { render, staticRenderFns } from "./BankAccountComponent.vue?vue&type=template&id=2a7f9e08&"
import script from "./BankAccountComponent.vue?vue&type=script&lang=js&"
export * from "./BankAccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports